import { render, staticRenderFns } from "./GroupSelector.vue?vue&type=template&id=41444438&scoped=true"
import script from "./GroupSelector.vue?vue&type=script&lang=js"
export * from "./GroupSelector.vue?vue&type=script&lang=js"
import style0 from "./GroupSelector.vue?vue&type=style&index=0&id=41444438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41444438",
  null
  
)

export default component.exports